<div class="upload-field">
  <div #buttonsRightTemplate>
    <coin-v2-button
      [type]="'primary'"
      [icon]="'upload'"
      [iconPos]="'right'"
      [text]="'Add Structure List Entry'"
      (click)="openCreateStructureListEntryPopup()"></coin-v2-button>
  </div>
</div>

<ci-simple-table
  [header]="selectedTableHeaders"
  [service]="structureListService"
  [serverPaginated]="true"
  [serverside]="true"
  [presetQueryParams]="queryParameters$ | async"
  [updaterIntervalInMs]="updaterIntervalInMs">
  <ng-template
    #columns
    let-item>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <i
              class="edit-button material-icons"
              (click)="openUpdateStructureListEntryPopup(item)">
              edit
            </i>
          </div>
        }
      </div>

      <div class="content-column">
        @if (item) {
          <div class="row">
            <i
              class="edit-button material-icons"
              (click)="openDeleteStructureListEntryPopup(item)">
              delete
            </i>
          </div>
        }
      </div>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.TargetOrgCode }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.Position }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.HeadGid }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.Acting }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.CreatedAt | date: 'MMM d, y (HH:mm)' : 'UTC' }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.CreatedByGid }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.LastModifiedAt | date: 'MMM d, y (HH:mm)' : 'UTC' }}
            </p>
          </div>
        }
      </div>
    </ng-container>
    <ng-container>
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.LastModifiedByGid }}
            </p>
          </div>
        }
      </div>
    </ng-container>
  </ng-template>
</ci-simple-table>
